import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './components/App/App'
// initialize native string override at entry
import initParamFormatter from './helpers/paramFormatter'
import db from './helpers/db'

initParamFormatter()
db.initialize()

ReactDOM.render(<App />, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js